/**
 * Authentification. Ces routes gèrent leur propre 401 (mauvais mot de passe, identité
 * initiale sans cookie…) : le transport ne déclenche pas « session expirée » pour elles.
 */
import { apiGet, apiPost, apiPut } from './client';

export interface AuthUser {
  id: string;
  email?: string;
  pseudonym: string;
  role: 'student' | 'admin';
}

export interface MePayload extends AuthUser {
  createdAt: string;
  lastActive: string;
  emailVerifiedAt?: string;
  /** null tant que le questionnaire de niveau n'a pas été validé ou passé. */
  onboardingCompletedAt?: string | null;
}

export function login(params: { email: string; password: string }): Promise<AuthUser> {
  return apiPost<AuthUser>('/api/auth/login', params);
}

export function register(params: { email: string; password: string; pseudonym: string }): Promise<AuthUser> {
  return apiPost<AuthUser>('/api/auth/register', params);
}

export function logout(): Promise<void> {
  return apiPost<void>('/api/auth/logout');
}

/** Identité de la session courante ; lève `ApiError` 401 quand personne n'est connecté. */
export function getMe(): Promise<MePayload> {
  return apiGet<MePayload>('/api/auth/me');
}

/**
 * Change le pseudonyme de l'utilisateur connecté. Le serveur retire les espaces autour,
 * exige 3 à 30 caractères (400) et refuse un pseudonyme déjà pris par un autre compte (409).
 */
export function updateProfile(params: { pseudonym: string }): Promise<void> {
  return apiPut<void>('/api/auth/profile', params);
}

export function requestPasswordReset(email: string): Promise<void> {
  return apiPost<void>('/api/auth/request-password-reset', { email });
}

export function resetPassword(params: { token: string; password: string }): Promise<void> {
  return apiPost<void>('/api/auth/reset-password', params);
}

export function getInvite(token: string): Promise<{ email: string }> {
  return apiGet<{ email: string }>(`/api/auth/invite/${encodeURIComponent(token)}`);
}

export function acceptInvite(params: { token: string; password: string; pseudonym?: string }): Promise<AuthUser> {
  return apiPost<AuthUser>('/api/auth/accept-invite', params);
}
